<!--
 * @Description: 流程图
 * @Author: wangwangwang
 * @Date: 2020-12-18 09:52:25
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-12-18 11:44:15
-->
<template>
  <el-dialog ref="infoDom" v-dialogDrag width="90%" title="流程图" :before-close="hanldeClose" :visible.sync="visible">
    <!-- 示例图 -->
    <div class="statusBox">
      <div class="status">
        <div class="item">
          <div class="icon icon1"></div>
          已经过的节点
        </div>
        <div class="item">
          <div class="icon icon2"></div>
          未经过的节点
        </div>
        <div class="item">
          <div class="icon icon3"></div>
          当前节点
        </div>
        <div class="item">
          <div class="beacon beacon1">
            <div class="line"></div>
            <div class="triangle"></div>
          </div>
          回退的路径
        </div>
        <div class="item">
          <div class="beacon beacon2">
            <div class="line"></div>
            <div class="triangle"></div>
          </div>
          流程的路径
        </div>
      </div>
    </div>
    <!-- 节点树 -->
    <div class="info">
      <template v-for="(item, index) in dataSource">
        <Tree :key="index" :tree="item" :fallbackList="fallbackList" :infoDom="infoDom" :index="index" @func="treeChange"></Tree>
      </template>
    </div>
    <!-- 流程返回线 -->
    <div v-if="isFallbackList" class="backLine">
      <template v-for="(item2, index2) in fallbackList2">
        <BackLine :key="index2" :index="index2" :lineData="item2" :startNode="startNode"></BackLine>
      </template>
    </div>
    <!--设置条件setConditions-->
    <!-- <setConditions :tableData="tableData" :conditionData="conditionData" :conditions="conditions" :conditionTable="conditionTable" :conditionVisible="conditionVisible" @closeVisible="closeVisible" /> -->
  </el-dialog>
</template>
<script>
import Tree from "./flowMapTree"
import BackLine from "./flowBackLine"
import bus from './bus';
// import setConditions from '@/views/platform/platform_item/Signed/processConfig/component/approval/setConditions.vue';
export default {
  props: ["visible", 'nodeDataSource', 'originalNodeList', 'nodeTableData', 'processNodeList'],
  components:{
    Tree,
    BackLine
    // setConditions
  },
  data () {
    return {
      dataSource: [],
      tableData:[],
      fallbackList:[],
      fallbackList2:[],
      conditionVisible: false,
      infoDom:"",
      treeList: [],
      isFallbackList: false,
      startNode: ""
    }
  },
  mounted() {
    bus.$on("setConditionEvent", (data, parentData) => {
      this.conditionData = data;
      this.conditionTable = data.data || ''; // 设置要展示的条件
      this.conditions = parentData.length;
      this.conditionVisible = true;
    });
  },
  watch: {
    visible (value) {
      if (value) {
        this.dataSource = this.nodeDataSource;
        console.log(this.nodeDataSource);
        this.tableData = this.nodeTableData;
        this.fallbackList = this.originalNodeList.filter(item => item.nodeType==7);
        this.dataSource = this.changeData();
        this.infoDom = ((this.$refs.infoDom.$el.innerHTML).split(">"))[0];
      }
    }
  },
  methods: {
    hanldeClose() {
      this.$emit("closeModel");
    },
    closeVisible() {
      this.conditionVisible = false;
    },
    /* 
    * 生成流程图中没有id，只能通过接口转换获取
    */
    // 查找筛选
    changeData() {
      this.fallbackList.forEach(item => {
        this.processNodeList.forEach(item2 => {
          if(item.processSourceNodeId == item2.id) {
            this.forDataSource2(this.dataSource, item2.code, item.processSourceNodeId, item.processTargetNodeId);
          }
        })
      })
      return this.dataSource
    },
    // 数组赋值
    forDataSource(item, code, processSourceNodeId, processTargetNodeId) {
      if(item.nodeId == code){
        item.processSourceNodeId = processSourceNodeId;
        item.processTargetNodeId = processTargetNodeId;
      }
      return item;
    },
    // 数组递归
    forDataSource2(arr, code, processSourceNodeId, processTargetNodeId) {
      arr.forEach(item => {
        if(item.childNode){
          item.childNode = this.forDataSource2(item.childNode, code, processSourceNodeId, processTargetNodeId);
        }
        item = this.forDataSource(item, code, processSourceNodeId, processTargetNodeId);
      })
      return arr;
    },
    /* 
    * 把数据中回退节点的开始节点和结束节点数据
    * 赋值给流程图数据
    */
    treeChange(data) {
      this.$nextTick(() => {
        let startNode = this.dataSource.filter(item => item.stepType==1);
        if(data.id == startNode[0].id) {
          this.startNode = data;
        }
        this.treeList.push(data);
        this.backLineList();
      })
    },
    backLineList() {
      this.isFallbackList = true;
      this.fallbackList2 = this.fallbackList.filter(item =>item.processSourceNodeId && item.processTargetNodeId)
      this.backLineList3(this.fallbackList);
    },
    backLineList2(item) {
      if(item.processSourceNodeId && item.processTargetNodeId) {
        this.treeList.forEach(item2 => {
          if(item.processSourceNodeId == item2.id) {
            item.processSourceOrigin = item2;
          }
        })
        this.treeList.forEach(item2 => {
          if(item.processTargetNodeId == item2.id) {
            item.processTargetOrigin = item2;
          }
        })
      }
      return item;
    },
    backLineList3(arr) {
      arr.forEach(item => {
        if(item.childNode) {
          item.childNode = this.backLineList3(item.childNode);
        }
        item = this.backLineList2(item);
      })
      return arr;
    }
  }
}
</script>
<style scoped lang="scss">
.statusBox{
  width: 80%;
  margin: 0 auto;
  height: 80px;
}
.status{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.item{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 40px;
  color: #000;
}
.icon{
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.icon1{
  background: #f1f1f1;
  border: 1px solid #ccc;
}
.icon2{
  background: #fff;
  border: 1px solid #00b85c;
}
.icon3{
  background: #00b85c;
  border: 1px solid #00b85c;
}
.beacon{
  width: 40px;
  margin-right: 5px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.beacon1{
  .line{
    width: 30px;
    height: 1px;
    background-color: #DA5455;
  }
  .triangle{
    width:0;
    height:0;
    border-top: 5px solid transparent;
    border-left: 10px solid #DA5455;
    border-bottom: 5px solid transparent;
  }
}
.beacon2{
  .line{
    width: 30px;
    height: 1px;
    background-color: #00b85c;
  }
  .triangle{
    width:0;
    height:0;
    border-top: 5px solid transparent;
    border-left: 10px solid #00b85c;
    border-bottom: 5px solid transparent;
  }
}
</style>
